import React from 'react'
import { IconButton } from 'react-toolbox/lib/button'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import cn from 'classnames'
import { BUG_ACTION_LABELS } from './constants'


import styles from './styles.scss'

const getClass = (bugAction) => {
  return BUG_ACTION_LABELS.find(match => 
    bugAction.toLowerCase().includes(match[0])
  )[1]
}

const BugActionLabel = ({ bugAction }) => {
  const classColor = getClass(bugAction)
  return (
    <span class={cn(styles.label, styles[classColor])}>
      {bugAction}
    </span>
  )
}

export default compose(
  CSSModules(styles)
)(BugActionLabel)
